import React from 'react'
import Navbar from '../../Components/Navbar'
import { Helmet } from 'react-helmet'

const ErrorElement = () => {
    return (
        <div>
            <Helmet>
                <title>Error</title>
            </Helmet>
            <Navbar />
            ErrorElement
        </div>
    )
}

export default ErrorElement